import { Component } from '@theme/component';

/**
 * SD Price & Rating
 *
 * The review app renders its rating summary as `<a role="link" tabindex="0">` with a
 * click handler and no href, so it already jumps to the reviews section on click — but
 * not from the keyboard: Enter does nothing, and Space only scrolls the page. This
 * forwards those keys to the element's own click, so the behaviour the app already has
 * is reachable without a mouse.
 *
 * Delegated from the block root, so a summary the app injects after first paint (or
 * re-renders) is covered without watching the DOM. Nothing else about the app's markup
 * is touched: its own label and roles stay as they are.
 *
 * @extends {Component}
 */
class SdPriceRating extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.#onKeydown);
  }

  #onKeydown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const target = event.target instanceof Element ? event.target : null;
    // Only the app's own hrefless link — a real link or button here handles its own keys.
    const link = target?.closest('a[role="link"]:not([href])');
    if (!link || !this.contains(link)) return;
    event.preventDefault();
    link.click();
  };
}

if (!customElements.get('sd-price-rating')) {
  customElements.define('sd-price-rating', SdPriceRating);
}
